import CommonSelect from './Select';

export default CommonSelect;
